import prd_RNRm5u6KKjPs from '@/data/products/one-time/prd_RNRm5u6KKjPs'
import type { UpsellTemplateSchema, UpsellTemplateStepConfig } from '../@types/upsell-types'
import type { OneTimeProduct } from '@/composables/useProducts'
import { mergeDeep } from '@/helpers/utils'
import prd_63Vnvsy5CEUP from '@/data/products/one-time/prd_63Vnvsy5CEUP'

export default (schema: UpsellTemplateSchema<OneTimeProduct>): UpsellTemplateSchema<OneTimeProduct> =>
	mergeDeep(
		{ ...schema },
		{
			config: {
				steps: (): UpsellTemplateStepConfig[] => {
					return [
						{
							product: prd_RNRm5u6KKjPs.ident,
							discountPercent: 45,
							modals: {
								skip: ['UpsellSkipPriorityModal'],
							},
						},
						{
							product: prd_63Vnvsy5CEUP.ident,
							discountPercent: 60,
						},
					]
				},
			},
		},
	)
